module.exports = __webpack_public_path__ + "static/media/arrow-down-green.8813cedb.svg";